
import { Button } from "@/components/ui/button";
import type { IntakeData } from "@/lib/types";
import { CheckCircle } from "lucide-react";
import { Trans } from "@lingui/macro";

interface ComprehensiveDentalAnalysisProps {
  data: IntakeData;
  onUpdate: (data: Partial<IntakeData>) => void;
  onNext: () => void;
}

export default function ComprehensiveDentalAnalysis({
  onNext,
}: ComprehensiveDentalAnalysisProps) {
  // Auto-proceed when component mounts
  // Auto-proceed logic removed to allow back navigation
  // useEffect(() => {
  //   if (Object.values(data.photos ?? {}).some(Boolean)) {
  //     proceedToNext();
  //   }
  // }, []);



  return (
    <div className="min-h-screen py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="w-16 h-16 border-2 border-[#166B93] rounded-2xl flex items-center justify-center mx-auto shadow-lg">
            <CheckCircle className="w-8 h-8 text-[#166B93]" />
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
              <Trans>Photos Received Successfully</Trans>
            </h1>
            <p className="text-lg text-gray-600">
              <Trans>
                Your dental photos have been submitted and will be reviewed by
                our specialists
              </Trans>
            </p>
          </div>
        </div>

        {/* Success Message */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div className="text-center space-y-6">
            <div className="w-20 h-20 bg-[#CEF12F]/10 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-10 h-10 text-[#CEF12F]" />
            </div>
            <div className="space-y-2">
              <h2 className="text-xl font-semibold text-gray-900">
                <Trans>Thank You!</Trans>
              </h2>
              <p className="text-gray-600">
                <Trans>
                  Thank you for uploading your photos. Please continue to the
                  next steps to complete your full analysis.
                </Trans>
              </p>
            </div>
            <div className="bg-blue-50 rounded-lg p-4">
              <p className="text-sm text-blue-800">
                <strong>
                  <Trans>Next Steps:</Trans>
                </strong>{" "}
                <Trans>
                  Continue through the remaining questions so our dental
                  specialists can finalize your personalized treatment plan.
                </Trans>
              </p>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <div className="flex justify-center">
          <Button
            onClick={onNext}
            className="bg-[#166B93] hover:bg-[#166B93]/90 text-white py-3 px-8 text-lg font-semibold"
          >
            <Trans>Continue to Next Step</Trans>
          </Button>
        </div>
      </div>
    </div>
  );
}
